
import { Injectable, Inject } from '@angular/core';
import { ENVIRONMENT, Environment } from 'model-utility';
import { filter } from 'rxjs'; // removed skip
import { NavigationEnd, Router, Event as RouterEvent } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PageLoadEventService {
  private readonly PAGE_LOADED = 'pageLoaded';

  constructor(
    private router: Router,
    @Inject(ENVIRONMENT) private env: Environment,
  ) {
    // LOG 1: Is the service even being created?
    console.log('[Angular Service] PageLoadEventService constructor called.');

    // LOG 2: What is the value of TEST_MODE?
    console.log(`[Angular Service] TEST_MODE environment variable is: "${this.env?.TEST_MODE}"`);

    if (this.env?.TEST_MODE !== 'enable') {
      // LOG 3: Did the service exit early?
      console.log('[Angular Service] Exiting because TEST_MODE is not "enable". No events will be dispatched.');
      return;
    }

    console.log('[Angular Service] TEST_MODE is enabled. Starting navigation listener.');
    this.startNavigationListener();
  }

  private startNavigationListener() {
    this.router.events
      .pipe(
        // LOG 4: Are we receiving ANY router events at all?
        // This will log NavigationStart, GuardsCheckEnd, etc. Very useful for debugging.
        // tap((e: RouterEvent) => console.log('[Angular Router Event]', e)),

        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      )
      .subscribe((nav: NavigationEnd) => {
        // LOG 5: Did a NavigationEnd event occur?
        console.log('[Angular Service] NavigationEnd detected for URL:', nav.urlAfterRedirects);

        // LOG 6: Are we dispatching the event?
        console.log(`[Angular Service] Dispatching "${this.PAGE_LOADED}" event.`);
        globalThis.dispatchEvent(new CustomEvent(this.PAGE_LOADED, {
          detail: { url: nav.urlAfterRedirects },
        }));
      });
  }
}
